import spinnerImg from '../../tnew/images/busy-spinner.gif';

const imageClassName = 'tn-busy-spinner__image';

const busySpinner = `
<div class="tn-busy-spinner">
  <img class="${imageClassName}" src="${spinnerImg}" alt="Loading" />
</div>`;

export default busySpinner;

export { imageClassName };
